module.exports = __webpack_public_path__ + "static/media/container.c90d90c4.svg";